import './skeleton.scss';

const Skeleton = (props) => {
  const { width = `100%`, height = `100%` } = props;
  return <div className="skeleton" style={{ width, height }}></div>;
};

export default Skeleton;
